<template>
  <a-modal :visible="visible" @ok="process" @cancel="cancel" :width="getScreen?'100%':'70%'" :confirmLoading="loading.confirm"
    okText="Submit"
    cancelText="Cancel"
    :maskClosable="false">
    <span slot="title"> <a-icon type="reconciliation" />&nbsp;Edit LKPD Recapitulation</span>

    <a-form-model
      ref="formDialog"
      :model="formDialog.form"
      :rules="formDialog.rules"
    >
      <a-row :gutter="14">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-model-item label="Currency">
            <a-radio-group
              buttonStyle="solid"
              v-model="formDialog.form.currency"
              @change="changeCurrency"
            >
              <a-radio-button value="IDR">IDR</a-radio-button>
              <a-radio-button value="USD">USD</a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-row :gutter="14">
            <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
              <a-row :gutter="14">
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <a-form-model-item v-if="formDialog.form.currency=='USD'" :label="'Exchange Rate to IDR'" prop="exchange_rate">
                    <a-input-number
                      :min="0"
                      class="m-width-full m-text-align-right" style="padding-right: 15px;"
                      :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                      @keydown="onlyNumber"
                      @change="changeRate"
                      v-model="formDialog.form.exchange_rate"
                    ></a-input-number>
                  </a-form-model-item>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <a-form-model-item v-if="formDialog.form.currency=='USD'" :label="'Total Recapitulation ('+formDialog.form.currency+')'" prop="total_rekap_usd">
                    <a-input-number
                      :min="0"
                      class="m-width-full m-text-align-right"
                      :formatter="(value) => `${initCUr} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="(value) => value.replace(formDialog.form.currency, '')"
                      @keydown="onlyNumber"
                      disabled
                      v-model="formDialog.form.total_rekap_usd"
                    ></a-input-number>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="14">
                <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
                  <a-form-model-item label="Total Recapitulation (IDR)" prop="total_rekap">
                    <a-input-number
                      :min="0"
                      class="m-width-full m-text-align-right"
                      :formatter="(value) => `${initCUrIDR} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="(value) => value.replace(formDialog.form.currency, '')"
                      @keydown="onlyNumber"
                      disabled
                      v-model="formDialog.form.total_rekap"
                    ></a-input-number>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              
            </a-col>
          </a-row>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-model-item label="Description" prop="description">
            <a-textarea placeholder="Write the note here ... " :rows="1" v-model="formDialog.form.description" />
          </a-form-model-item>
          <a-form-model-item label="Document Support" prop="document_support">
                <a-upload :fileList="formDialog.fileList" v-model="formDialog.form.document_support" :remove="handleRemove" :beforeUpload="beforeUpload">
                  <a-button>
                    <a-icon type="upload" />Select File
                  </a-button>
                </a-upload>
              </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <a-table
      :rowKey="(record, index) => {return index;}"
      :columns="columnsList"
      :dataSource="dataSource"
      :pagination="pagination"
      :loading="loading.table"
      size="small"
      class="table"
      :scroll="{ x: 400 }"
      bordered
    >
      <template slot="title">
        <div class="m-display-flex space-end">Selected: {{selectedList.length}}</div>
      </template>
      <template slot="no" slot-scope="item,data,index">
        {{ index+1 }}
      </template>
      <template slot="no_klaim" slot-scope="item">
        {{ item.no_pdlk ? item.no_pdlk : item.no_sppd }}
      </template>
      <template slot="create_date" slot-scope="item">
        {{ moment(item.create_dt).format(getStandartFormatDate) }} / {{ item.tlc_buat }}
      </template>
      <template slot="member_name" slot-scope="item">
        {{ item.tlc }} | {{ item.nama }}
      </template>
      <template slot="total_hari" slot-scope="item">
        {{ item.hari }}
      </template>
      <template slot="total_ins_pd" slot-scope="item">
        <span v-if="formDialog.form.currency=='USD'">{{ formatCurrency('USD',item.total_ln) }}</span>
        <span v-else>{{ formatCurrency('IDR',item.total_pd) }}</span>
      </template>
      <template slot="action" slot-scope="item">
        <a-checkbox v-model="item.checked" @change="(e)=>{synchCheckedtoOri(e.target.checked,item)}"/>
      </template>
    </a-table>
  </a-modal>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "DialogProcess",
  mixins: [CurrencyFormat, GlobalMethod],
  props: ["visible","detail"],
  data(){
    let doc_validation = (rule, value, callback) => {
      if (this.formDialog.fileList == null || this.formDialog.fileList.length==0) {
        callback(new Error("Upload File Cannot be Empty!"));
      } else {
        callback();
      }
    };

    const columnsList = [
      {
        title: "#",
        key: "no",
        width: "50px",
        align: "center",
        scopedSlots: { customRender: "no" },
        sorter: (a, b) => a.no - b.no,
      },
      {
        title: "Created Date / TLC",
        key: "create_date",
        width: "150px",
        align: "center",
        scopedSlots: { customRender: "create_date" },
        sorter: (a, b) => a.tgl_buat - b.tgl_buat,
      },
      {
        title: "No LKPD/SPPD",
        key: "no_klaim",
        width: "280px",
        align: "center",
        scopedSlots: { customRender: "no_klaim" },
        sorter: (a, b) => a.no_klaim - b.no_klaim,
      },
      {
        title: "Assignee",
        key: "member_name",
        align: "left",
        scopedSlots: { customRender: "member_name" },
        sorter: (a, b) => a.tlc - b.tlc,
      },
      {
        title: "Total Days",
        key: "total_hari",
        width: "100px",
        align: "right",
        scopedSlots: { customRender: "total_hari" },
        sorter: (a, b) => a.hari - b.hari,
      },
      {
        title: "Total LKPD Insentif (IDR)",
        key: "total_ins_pd",
        width: "180px",
        align: "right",
        scopedSlots: { customRender: "total_ins_pd" },
        sorter: (a, b) => a.total_pd - b.total_pd,
      },
      {
        title: "Action",
        key: "action",
        width: "65px",
        align: "center",
        scopedSlots: { customRender: "action" },
        fixed: "right"
      },
    ];

    return {
      columnsList,
      loading: {
        confirm: false,
        table: false
      },
      formDialog:{
        form: {
          total_rekap: 0,
          total_rekap_usd: 0,
          description: null,
          document_support: null,
          currency: "IDR",
          exchange_rate: null
        },
        rules: {
          total_rekap: {
            required: true,
            message: "Total Recapitulation is required!",
            trigger: "change",
          },
          description: {
            required: true,
            message: "Description is required!",
            trigger: "change",
          },
          document_support: {
            required: false,
            // validator: doc_validation,
            message: "Document Support is required!",
            trigger: "change",
          },
          currency: {
            required: true,
            message: "Currency is required!",
            trigger: "change",
          },
        },
        fileList:[],
      },
      pagination: {
        onChange: (page) => {},
        pageSize: 4,
        size: "small",
      },
      dataSource: [],
      headSource: [],
      selectedList: []
    }
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getScreen",
      "getStandartFormatDate"
    ]),
    initCUr() {
      return this.symbolCurrencyES6(this.formDialog.form.currency, 0);
    },
    initCUrIDR() {
      return this.symbolCurrencyES6('IDR', 0);
    },
  },
  mounted(){
    this.dataSource = this.detail.dtl
    this.headSource = this.detail.data[0]
    this.selectedListed()
    this.formDialog.form.currency = this.headSource.kurs=="1" ? "IDR" : "USD"
    this.resetvalue()
  },
  methods:{
    moment,
    resetvalue(){
      this.formDialog.form.description = this.headSource.description
      this.formDialog.form.total_rekap = this.headSource.kurs=='1' ? this.headSource.total_value : this.headSource.total_value_old*this.headSource.kurs
      this.formDialog.form.total_rekap_usd = this.headSource.total_value_old
      this.formDialog.form.exchange_rate = this.headSource.kurs
      this.formDialog.form.file_doc_rekap = this.headSource.file_doc_rekap
    },
    process(){
      this.$refs.formDialog.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();
        formData.append("id_rekap_lkpd", this.headSource.id_rekap_lkpd);
        formData.append("description", this.formDialog.form.description);
        formData.append("total", this.formDialog.form.exchange_rate=='1' ? this.formDialog.form.total_rekap : this.formDialog.form.total_rekap_usd);
        formData.append("kurs", this.formDialog.form.exchange_rate);
        if(this.formDialog.fileList && this.formDialog.fileList.length>0)
          formData.append(`file_support`, this.formDialog.fileList[0]);

        if(this.selectedList.length>0){
          this.selectedList.forEach((element,index) => {
            formData.append(`selected_item[${index}]`, element.new_id);
          });
        }else{
          this.displayMessageValue("error-other", 'No data Selected!');
          return
        }

        this.loading.confirm = true
        this.asyncAxiosPost("rekap_lkpd/edit",
          "formdata", this.getAuth, formData)
        .then(() => {
          Event.$emit("closeDiagEditRec");
          Event.$emit("fetchData");
          this.displayMessage("success-save");
          this.loading.confirm = false
        })
        .catch(() => {
        });
      })
    },
    cancel(){
      Event.$emit("closeDiagEditRec");
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else {
        this.formDialog.fileList = [file];
        return false;
      }
    },
    handleRemove() {
      this.formDialog.fileList = [];
    },
    selectedListed(){
      this.selectedList =  this.dataSource.filter(item=>item.checked==true)
      if(this.formDialog.form.currency=="USD"){
        this.formDialog.form.total_rekap_usd = _.sumBy(this.selectedList, function (val) {
          return val.checked? Number(val.total_ln) : 0;
        });
        this.changeRate(this.formDialog.form.exchange_rate)
      }else{
        this.formDialog.form.total_rekap = _.sumBy(this.selectedList, function (val) {
          return val.checked? Number(val.total_pd) : 0;
        });
      }
    },
    synchCheckedtoOri(val, params){
      this.loading.table = true
      this.dataSource.forEach(element => {
        if(element.new_id==params.new_id){
          element.checked = val
          this.selectedListed()
          this.loading.table = false
        }
      });
    },
    sumTotalSelected(){
      // this.formDialog.form.total_rekap = _.sumBy(this.selectedList, function (val) {
      //   return val.total_pd ? Number(val.total_pd) : 0
      // });
    },
    sumTotalSelectedUSD(){
      // this.formDialog.form.total_rekap_usd = _.sumBy(this.selectedList, function (val) {
      //   return val.total_ln ? Number(val.total_ln) : 0
      // });
      // this.formDialog.form.total_rekap = 0
    },
    changeCurrency(val){
      this.formDialog.form.exchange_rate = 0
      this.resetvalue()
      this.selectedListed()
      if(val.target.value=="USD"){
        this.sumTotalSelectedUSD()
      }else{
        this.formDialog.form.exchange_rate = "1"
        this.sumTotalSelected()
      }
    },
    changeRate(val){
      if(val){
        this.formDialog.form.total_rekap = this.formDialog.form.total_rekap_usd*val
      }else{
        this.formDialog.form.total_rekap = 0
      }
    }
  }
}
</script>
<style lang="less">
  .ant-input-number-input{
    text-align: right;
  }
</style>